import React, { createContext, useState, useEffect } from "react";
// import { timezones } from "../utils/timezones"; // Adjust path if needed

 export const timezones = [
    { label: "(GMT) Coordinated Universal Time", tz: "Etc/UTC" },
    { label: "(GMT -11:00) Midway Island", tz: "Pacific/Midway" },
    { label: "(GMT -11:00) Samoa", tz: "Pacific/Pago_Pago" },
    { label: "(GMT -10:00) Hawaii", tz: "Pacific/Honolulu" },
    { label: "(GMT -8:00) Alaska", tz: "America/Anchorage" },
    { label: "(GMT -7:00) Arizona", tz: "America/Phoenix" },
    { label: "(GMT -7:00) Baja California", tz: "America/Tijuana" },
    {
      label: "(GMT -7:00) Pacific Time (US & Canada)",
      tz: "America/Los_Angeles",
    },
    {
      label: "(GMT -6:00) Chihuahua, La Paz, Mazatlan",
      tz: "America/Chihuahua",
    },
    {
      label: "(GMT -6:00) Guadalajara, Mexico City, Monterrey",
      tz: "America/Mexico_City",
    },
    { label: "(GMT -6:00) Mountain Time (US & Canada)", tz: "America/Denver" },
    { label: "(GMT -5:00) Bogota, Lima, Quito", tz: "America/Bogota" },
    { label: "(GMT -5:00) Central America", tz: "America/Guatemala" },
    { label: "(GMT -5:00) Central Time (US & Canada)", tz: "America/Chicago" },
    { label: "(GMT -5:00) Saskatchewan", tz: "America/Regina" },
    { label: "(GMT -4:00) Asuncion", tz: "America/Asuncion" },
    { label: "(GMT -4:00) Caracas", tz: "America/Caracas" },
    { label: "(GMT -4:00) Cuiaba", tz: "America/Cuiaba" },
    { label: "(GMT -4:00) Eastern Time (US & Canada)", tz: "America/New_York" },
    {
      label: "(GMT -4:00) Georgetown, La Paz, Manaus, San Juan",
      tz: "America/La_Paz",
    },
    { label: "(GMT -4:00) Indiana (East)", tz: "America/Indiana/Indianapolis" },
    { label: "(GMT -4:00) Santiago", tz: "America/Santiago" },
    { label: "(GMT -3:00) Atlantic Time (Canada)", tz: "Canada/Atlantic" },
    { label: "(GMT -3:00) Brasilia", tz: "America/Sao_Paulo" },
    { label: "(GMT -3:00) Buenos Aires", tz: "America/Argentina/Buenos_Aires" },
    { label: "(GMT -3:00) Cayenne, Fortaleza", tz: "America/Fortaleza" },
    { label: "(GMT -3:00) Montevideo", tz: "America/Montevideo" },
    { label: "(GMT -2:30) Newfoundland", tz: "America/St_Johns" },
    { label: "(GMT -2:00) Greenland", tz: "America/Godthab" },
    { label: "(GMT -1:00) Cape Verde Is.", tz: "Atlantic/Cape_Verde" },
    { label: "(GMT) Azores", tz: "Atlantic/Azores" },
    { label: "(GMT) Coordinated Universal Time", tz: "Etc/UTC" },
    { label: "(GMT) Monrovia, Reykjavik", tz: "Atlantic/Reykjavik" },
    { label: "(GMT +1:00) Casablanca", tz: "Africa/Casablanca" },
    {
      label: "(GMT +1:00) Dublin, Edinburgh, Lisbon, London",
      tz: "Europe/London",
    },
    { label: "(GMT +1:00) Lagos", tz: "Africa/Lagos" },
    { label: "(GMT +1:00) West Central Africa", tz: "Africa/Algiers" },
    {
      label: "(GMT +2:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
      tz: "Europe/Berlin",
    },
    {
      label: "(GMT +2:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
      tz: "Europe/Belgrade",
    },
    {
      label: "(GMT +2:00) Brussels, Copenhagen, Madrid, Paris",
      tz: "Europe/Paris",
    },
    { label: "(GMT +2:00) Cairo", tz: "Africa/Cairo" },
    { label: "(GMT +2:00) Johannesburg", tz: "Africa/Johannesburg" },
    {
      label: "(GMT +2:00) Sarajevo, Skopje, Warsaw, Zagreb",
      tz: "Europe/Warsaw",
    },
    { label: "(GMT +2:00) Windhoek", tz: "Africa/Windhoek" },
    { label: "(GMT +3:00) Amman", tz: "Asia/Amman" },
    { label: "(GMT +3:00) Baghdad", tz: "Asia/Baghdad" },
    { label: "(GMT +3:00) Beirut", tz: "Asia/Beirut" },
    { label: "(GMT +3:00) Damascus", tz: "Asia/Damascus" },
    {
      label: "(GMT +3:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
      tz: "Europe/Kiev",
    },
    { label: "(GMT +3:00) Istanbul", tz: "Europe/Istanbul" },
    { label: "(GMT +3:00) Jerusalem", tz: "Asia/Jerusalem" },
    { label: "(GMT +3:00) Kuwait, Riyadh", tz: "Asia/Riyadh" },
    {
      label: "(GMT +3:00) Moscow, St. Petersburg, Volgograd",
      tz: "Europe/Moscow",
    },
    { label: "(GMT +3:00) Nairobi", tz: "Africa/Nairobi" },
    { label: "(GMT +3:30) Tehran", tz: "Asia/Tehran" },
    { label: "(GMT +4:00) Abu Dhabi, Dubai, Muscat", tz: "Asia/Dubai" },
    { label: "(GMT +4:00) Baku", tz: "Asia/Baku" },
    { label: "(GMT +4:30) Kabul", tz: "Asia/Kabul" },
    { label: "(GMT +5:00) Ekaterinburg", tz: "Asia/Yekaterinburg" },
    { label: "(GMT +5:00) Karachi", tz: "Asia/Karachi" },
    {
      label: "(GMT +5:30) Chennai, Kolkata, Mumbai, New Delhi",
      tz: "Asia/Kolkata",
    },
    { label: "(GMT +5:30) Colombo", tz: "Asia/Colombo" },
    { label: "(GMT +5:45) Kathmandu", tz: "Asia/Kathmandu" },
    { label: "(GMT +6:00) Dhaka", tz: "Asia/Dhaka" },
    { label: "(GMT +6:30) Yangon (Rangoon)", tz: "Asia/Yangon" },
    { label: "(GMT +7:00) Bangkok, Hanoi, Jakarta", tz: "Asia/Bangkok" },
    {
      label: "(GMT +8:00) Beijing, Chongqing, Hong Kong, Urumqi",
      tz: "Asia/Shanghai",
    },
    { label: "(GMT +8:00) Manila", tz: "Asia/Manila" },
    { label: "(GMT +8:00) Singapore", tz: "Asia/Singapore" },
    { label: "(GMT +9:00) Osaka, Sapporo, Tokyo", tz: "Asia/Tokyo" },
    { label: "(GMT +9:00) Seoul", tz: "Asia/Seoul" },
    { label: "(GMT +9:30) Adelaide", tz: "Australia/Adelaide" },
    { label: "(GMT +10:00) Brisbane", tz: "Australia/Brisbane" },
    {
      label: "(GMT +10:00) Canberra, Melbourne, Sydney",
      tz: "Australia/Sydney",
    },
    { label: "(GMT +10:00) Vladivostok", tz: "Asia/Vladivostok" },
    {
      label: "(GMT +11:00) Solomon Is., New Caledonia",
      tz: "Pacific/Guadalcanal",
    },
    { label: "(GMT +12:00) Auckland, Wellington", tz: "Pacific/Auckland" },
    { label: "(GMT +12:00) Eniwetok, Kwajalein", tz: "Pacific/Kwajalein" },
  ];
export const TimezoneContext = createContext();

export const TimezoneProvider = ({ children }) => {
  const [selectedZone, setSelectedZone] = useState(timezones[0]);


useEffect(() => {
  const storedLabel = localStorage.getItem("Timezone Selected");
  if (storedLabel) {
    const found = timezones.find(z => z.label === storedLabel);
    if (found) setSelectedZone(found);
  }
}, []);





useEffect(() => {
  localStorage.setItem("Timezone Selected", selectedZone.label);
}, [selectedZone]);

useEffect(()=>{
  setSelectedZone(timezones[0]);
},[])



  return (
    <TimezoneContext.Provider value={{ selectedZone, setSelectedZone }}>
      {children}
    </TimezoneContext.Provider>
  );
};
